import React, { useEffect, useState } from 'react'
import { Image } from 'theme-ui'
import { getOutroImages } from './ImageHelper'
import useWindowSize from '~/hooks/components/use-window-size'

const ShuffledImages = ({ sectionRef }) => {
  const { width } = useWindowSize()
  const [enteredArr, setEnteredArr] = useState([])
  const images = getOutroImages(width)
  const staggerDelay = 200

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          images.forEach((_, idx) => {
            setTimeout(() => {
              setEnteredArr(prev => {
                const next = [...prev]
                next[idx] = true
                return next
              })
            }, idx * staggerDelay)
          })
          observer.disconnect()
        }
      },
      { threshold: 0.1 },
    )
    if (sectionRef.current) {
      observer.observe(sectionRef.current)
    }
    return () => observer.disconnect()
  }, [])

  const randomDeg = () => {
    const deg = Math.random() * 3 + 1
    return (Math.random() > 0.5 ? '' : '-') + deg.toFixed(2)
  }

  return (
    <>
      {images.map(
        (
          {
            src,
            alt,
            maxWidthMobile = 'min(200px, 30vw)',
            maxWidthTablet = 'min(200px, 30vw)',
            maxWidthDesktop = 'min(350px, 30vw)',
            minWidth = ['120px', '120px', '200px'],
            top,
            bottom,
            left,
            right,
            zIndex,
            display,
          },
          index,
        ) => {
          return (
            <Image
              key={index}
              src={src}
              alt={alt}
              sx={{
                display: display,
                position: 'absolute',
                top: enteredArr[index] ? top : '50%',
                left: enteredArr[index] ? left : '50%',
                transform: enteredArr[index]
                  ? 'unset'
                  : 'translate(-50%, -50%)',
                right: enteredArr[index] ? right : 'unset',
                bottom: enteredArr[index] ? bottom : 'unset',
                zIndex: zIndex,
                maxWidth: [maxWidthMobile, maxWidthTablet, maxWidthDesktop],
                minWidth,
                height: 'auto',
                opacity: enteredArr[index] ? 1 : 0,
                transition: `all 1s cubic-bezier(0.77, 0, 0.175, 1)`,
                ...(enteredArr[index] && {
                  '&:hover': {
                    transform: `scale(1.2) rotate(${randomDeg()}deg)`,
                    transition: 'all 0.2s ease-in-out',
                  },
                }),
              }}
            />
          )
        },
      )}
    </>
  )
}

export default ShuffledImages
